/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module, Logger, DynamicModule, Provider } from '@nestjs/common';
import { DiscoveryModule, Reflector } from '@nestjs/core';
import { AutomationController } from '@/controllers/automation.controller';
import { AutomationService } from '@/services/automation.service';
import { AutomationDiscoveryService } from '@/services/automation-discovery.service';
import { TriggerClient } from '@/client/trigger-client';
import type { TriggerClientOptions } from '@/client/types';

/**
 * AutomationModule
 * 
 * 自动化任务模块，提供声明式任务注册与执行能力
 */
@Module({})
export class AutomationModule {
  /**
   * 创建并配置 AutomationModule
   * 
   * @param options - TriggerClient 配置选项
   * @returns 配置好的 DynamicModule
   */
  static forRoot(options: TriggerClientOptions = {}): DynamicModule {
    const providers: Provider[] = [
      {
        provide: TriggerClient,
        useFactory: () => {
          const logger = new Logger(TriggerClient.name);
          const client = new TriggerClient(logger);
          return client;
        },
      },
      Reflector,
      AutomationDiscoveryService,
      AutomationService,
    ];

    return {
      module: AutomationModule,
      imports: [DiscoveryModule, ...(options.imports || [])],
      controllers: [AutomationController],
      providers,
    };
  }
}
